import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';
import {INewOrderState} from '../models/new-order-state.model';

export const selectNewOrderState = createFeatureSelector<INewOrderState>(EState.newOrder);
export const selectProducts = createSelector(
  selectNewOrderState,
  (signUpState: INewOrderState) => signUpState?.products
);

export const selectCurrentProduct = createSelector(
  selectNewOrderState,
  (signUpState: INewOrderState) => signUpState?.selectedProduct
);
